import React from "react";
import { Modal } from "antd";
import type { ModalProps } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./appModal.scss";

// One width for every modal in the app. Do not add size/width variants.
export const MODAL_WIDTH = 640;

export type AppModalProps = Omit<ModalProps, "width" | "centered" | "closeIcon" | "style" | "bodyStyle">;

const AppModal: React.FC<AppModalProps> = ({
  className,
  maskClosable = false,
  footer = null,
  children,
  ...rest
}) => (
  <Modal
    {...rest}
    centered
    width={MODAL_WIDTH}
    maskClosable={maskClosable}
    footer={footer}
    closeIcon={<CloseOutlined />}
    className={["app-modal", className].filter(Boolean).join(" ")}
  >
    {children}
  </Modal>
);

export default AppModal;
